import React, { useContext } from 'react';
import { FilterBarContext, FilterFieldName } from '../FilterBarContext';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, IconButton } from '@mui/material';
import { Clear } from '@mui/icons-material';
import { TransactionSource } from '@/modules/transactions/api/transactions/transaction.contracts';
import { useTranslation } from '@/lib';
import { getTransactionSourceStyle } from '@/modules/transactions/types/TransactionModel';

interface TransactionSourceFilterProps {
  label: string;
}

const TransactionSourceFilter: React.FC<TransactionSourceFilterProps> = ({ label }) => {
  const { setFilterValue, filterValues } = useContext(FilterBarContext);
  const { t } = useTranslation();

  const handleChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    if (value === '') {
      setFilterValue(FilterFieldName.transactionSource, undefined);
    } else {
      const transactionSource = value as TransactionSource;
      // Get the human-readable translation (capitalized)
      const humanValue = t(transactionSource.toLowerCase());
      setFilterValue(FilterFieldName.transactionSource, transactionSource, humanValue);
    }
  };

  const handleClear = () => {
    setFilterValue(FilterFieldName.transactionSource, undefined);
  };

  return (
    <FormControl fullWidth size="small">
      <InputLabel>{label}</InputLabel>
      <Select
        value={filterValues.transactionSource || ''}
        onChange={handleChange}
        label={label}
        endAdornment={
          filterValues.transactionSource && (
            <IconButton className="absolute right-3 mr-6 flex" color="inherit" onClick={handleClear} aria-label="clear" size="small">
              <Clear />
            </IconButton>
          )
        }
      >
        <MenuItem value={TransactionSource.Manual}>
          <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-md font-medium ${
              getTransactionSourceStyle(TransactionSource.Manual).bg
            } ${getTransactionSourceStyle(TransactionSource.Manual).text}`}
          >
            {t('manual')}
          </span>
        </MenuItem>
        <MenuItem value={TransactionSource.Automatic}>
          <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-md font-medium ${
              getTransactionSourceStyle(TransactionSource.Automatic).bg
            } ${getTransactionSourceStyle(TransactionSource.Automatic).text}`}
          >
            {t('automatic')}
          </span>
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default TransactionSourceFilter;
